<template>
  <layout-content>
    <create-form />
  </layout-content>
</template>
<script>
  import CreateForm from '@autocaller_v2/components/campaigns-create-form';
  export default {
    components: { CreateForm }
  };
</script>
